import { memo } from 'react';
import { Box } from '@mui/material';

function TutorialArcade(): JSX.Element {
  return (
    <Box>
      <div style={{ position: 'relative', paddingBottom: 'calc(53% + 41px)', height: 0, width: '100%' }}>
        <iframe
          src="https://demo.arcade.software/3DuolCQTkxUoo5NjGa5a?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
          title="Effortless Opinion Categorization in Surveys"
          frameBorder="0"
          loading="lazy"
          allowFullScreen
          allow="clipboard-write"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', colorScheme: 'light' }}
        />
      </div>
      {/* 하단 버튼 영역 높이만큼 여백 추가 (버튼 높이 52px + 패딩 32px = 약 84px) */}
      <Box sx={{ height: { xs: 84, sm: 84 } }} />
    </Box>
  );
}

export default memo(TutorialArcade);
